import EFPicture from 'elem/compCommon/EFPicture';
import Computer from '@elem/SVGIcon/Camp/Computer';
import Light from '@elem/SVGIcon/Camp/Light';
import Power from '@elem/SVGIcon/Camp/Power';
import RiceCooker from '@elem/SVGIcon/Camp/RiceCooker';
import Refrigerator from '@elem/SVGIcon/Camp/Refrigerator';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('camp');
    const cards: any[] = [
        {
            icon: <Computer />,
            title: t('secD_card1_title'),
            desc: t('secD_card1_desc'),
        },
        {
            icon: <Light />,
            title: t('secD_card2_title'),
            desc: t('secD_card2_desc'),
        },
        {
            icon: <RiceCooker />,
            title: t('secD_card3_title'),
            desc: t.rich('secD_card3_desc', {
                a: (text: string) => (
                    <Link className="a-link" href={`https://${locale}.ecoflow.com/pages/portable-power-stations`}>
                        {text}
                    </Link>
                ),
            }),
        },
        {
            icon: <Power />,
            title: t('secD_card4_title'),
            desc: t('secD_card4_desc'),
        },
        {
            icon: <Refrigerator />,
            title: t('secD_card5_title'),
            desc: t('secD_card5_desc'),
        },
    ];
    return (
        <div id="camp-D" className={`camp-D camp-box ${css['camp-D']}`}>
            <h2 className="title">{t('secD_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/4.jpg'} alt={t('secD_title')} />
            </div>
            <p className="desc">{t('secD_desc')}</p>
            <div className="cards pc">
                {cards?.map((card: any, k: number) => (
                    <li className={`card ${k < 3 ? 'first-row' : 'last-row'}`} key={k}>
                        <div className="card-icon">{card?.icon}</div>
                        <p className="card-title">{card?.title}</p>
                        <p className="card-desc desc">{card.desc}</p>
                    </li>
                ))}
            </div>
            <Swiper
                className="cards h5"
                modules={[Scrollbar]}
                spaceBetween={20}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`card item-${k + 1}`} key={k}>
                        <div className="card-icon">{card?.icon}</div>
                        <p className="card-title">{card?.title}</p>
                        <p className="card-desc desc">{card.desc}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
